@if (showEmptyInViewMode || items?.length || editMode) {
  <div
    #viewport
    class="svc-mc-viewport"
    (scroll)="onViewportScroll()"
    [style.height.px]="itemHeight ? itemHeight : null"
  >
    <svc-media-carousel-item
      [item]="null"
      [class.hidden]="!emptyView || (items.length && (!editMode || (maxItems > 0 && items.length >= maxItems)))"
      [style.width.px]="(renderMode === 'list' && (!mustCenterEmptyViewWhenAlone || items.length)) ? itemWidth : null"
    />
    @for (item of items; track $index) {
      <svc-media-carousel-item
        [item]="item"
        [style.width.px]="renderMode === 'list' ? itemWidth : null"
      />
    }
  </div>
}

<!-- NAV-BUTTON PREVIOUS -->
@if (
  renderMode === 'list'
    ? viewportRemainingToStart > 0
    : currentIndex > 0 || (currentIndex === 0 && emptyView && (!items.length || (editMode && (maxItems <= 0 || items.length < maxItems))))
) {
  <button
    mat-icon-button
    class="svc-mc-nav-btn absolute bg-transparent w-7 h-7 min-h-7 top-1/2 left-0 -translate-y-1/2 text-on-primary"
    matTooltipPosition="above"
    [matTooltip]="'Anterior' | transloco"
    (click)="goToPrevious($event)"
  >
    <mat-icon
      class="text-current icon-size-6"
      svgIcon="heroicons_solid:chevron-left"
    />
  </button>
}

<!-- NAV-BUTTON NEXT -->
@if (renderMode === 'list' ? viewportRemainingToEnd > 0 : (!current && items.length) || (current && currentIndex < items.length - 1)) {
  <button
    mat-icon-button
    class="svc-mc-nav-btn absolute bg-transparent w-7 h-7 min-h-7 top-1/2 right-0 -translate-y-1/2 text-on-primary"
    matTooltipPosition="above"
    [matTooltip]="'Próximo' | transloco"
    (click)="goToNext($event)"
  >
    <mat-icon
      class="text-current icon-size-6"
      svgIcon="heroicons_solid:chevron-right"
    />
  </button>
}

